import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const ProfileOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M12 2.27c-5.37 0-9.73 4.36-9.73 9.73a9.69 9.69 0 0 0 2.66 6.68c.58.61 1.24 1.15 1.96 1.6 1.48.92 3.24 1.45 5.11 1.45s3.63-.53 5.11-1.45c.72-.45 1.38-.99 1.96-1.6A9.69 9.69 0 0 0 21.73 12c0-5.37-4.36-9.73-9.73-9.73Zm0 17.86c-2.1 0-4.01-.8-5.45-2.11.24-2.46 2.46-4.41 5.19-4.53.09.01.17.03.26.03s.17-.02.26-.03c2.73.12 4.95 2.07 5.19 4.53A8.07 8.07 0 0 1 12 20.13ZM10.08 10a1.92 1.92 0 0 1 3.84 0c0 .97-.73 1.76-1.66 1.89-.09 0-.17-.01-.26-.01s-.17.01-.26.01c-.93-.13-1.66-.92-1.66-1.89Zm4.52 2.35c.56-.63.92-1.45.92-2.35 0-1.94-1.58-3.52-3.52-3.52S8.48 8.06 8.48 10c0 .9.36 1.72.92 2.35-1.98.72-3.52 2.26-4.16 4.16A8.029 8.029 0 0 1 3.87 12c0-4.48 3.65-8.13 8.13-8.13s8.13 3.65 8.13 8.13c0 1.67-.5 3.22-1.37 4.51-.64-1.9-2.18-3.44-4.16-4.16Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default ProfileOutlined
